import React from 'react';

import { StyledImageContainer, StyledMedia } from './styled';

type MediaProps = {
  imgUrl: string;
};

const Media = ({ imgUrl }: MediaProps) => (
  <StyledMedia>
    <StyledImageContainer
      style={{
        backgroundImage: `url(${imgUrl})`,
      }}
    >
      <img src={imgUrl} alt={imgUrl} />
    </StyledImageContainer>
  </StyledMedia>
);

export default Media;
